import React from 'react';
import { connect } from 'react-redux';
import { isDefined } from '../../../utils';
import LoadingControl from '../../LoadingControl';

class TeamProfilePresentationCalibrationControl extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        const {
            name,
            agentCount,
            fullyJibedAgentsCount,
            jibeSessionsPast30DaysCount,
            backgroundImage,
        } = this.props;

        return <div className="flex-item box-style"
            style={{ backgroundImage: `url(${`../../../../../Assets/Images/V3Design/${backgroundImage}.png`})` }}>

            <div className="flex-container" style={{ minHeight: '80px', marginTop: '20px', marginLeft: '142px', marginRight: '26px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '20px' }}>
                    <p className="numbers-title">Team {name}</p>
                    <p className="agent-top-panel-title" style={{ marginBottom: '20px' }}>({agentCount} Agents)</p>
                    {/*<p className="agent-top-panel-title" style={{ marginTop: '5px' }}>Rank: 5/15</p>*/}
                    {/*<p className="agent-top-panel-title" style={{ marginTop: '5px' }}>Rank: 5/15</p>*/}
                </div>
                <div style={{ marginLeft: 'auto', marginTop: '5px' }}>
                    <p className="agent-top-panel-title" style={{ marginBottom: '20px' }}>Fully Jibed</p>
                    <p className="agent-top-panel-title" style={{ marginTop: '5px' }}>Jibe Sessions Last 30 Days</p>
                </div>
                <div style={{ marginLeft: '16px', marginRight: '5px' }}>
                    <p className="agent-top-panel-stats" style={{ marginBottom: '0' }}>{fullyJibedAgentsCount}</p>
                    <p className="agent-top-panel-stats" style={{ marginTop: '5px' }}>{jibeSessionsPast30DaysCount}</p>
                </div>
            </div>
        </div>
    };
}

const select = state => ({ session: state.session });

export default connect(select)(TeamProfilePresentationCalibrationControl);
